import React, { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SubscriptionsContext } from "contexts/subscriptions";
import { LocalizeText } from "components/localizer";
import TopBar from "components/tableComponents/topBar";
import Banner from "components/banner";
import { MembershipsContext } from "contexts/memberships";
import SearchField from "components/tableComponents/paginationSearchField";
import { SubscriptionsTable } from "components/tableComponents/subscriptionsTable";
import { usePaginationStore } from "utils/usePaginationStore";
import VKButton from "components/vkButton";
import ConfirmDialog from "components/confirmDialog";
import { List, ListItemText } from "@mui/material";

const SubscriptionsView: FC = () => {
    const { isFetchingMembership, membership, fetchMembership } = useContext(MembershipsContext);
    const { getBariumRequestMoreMembershipURL } = useContext(SubscriptionsContext);

    const { membershipId } = useParams<{ membershipId: string }>();
    const [showExternalLinkModal, setShowExternalLinkModal] = useState<"SHOW_MODAL" | "LOADING" | "NONE">("NONE");

    const pagination = usePaginationStore("subscriptions", undefined, {
        active: true,
        membership_id: membershipId,
        page_size: 10,
        default_page_size: 10,
    });

    useEffect(() => {
        if (!membership && !isFetchingMembership && membershipId) {
            fetchMembership(parseInt(membershipId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [membershipId]);

    const confirmExternalLinkModalDescription = (
        <List>
            <ListItemText
                primary={<LocalizeText tag="confirmExternalLinkModalText" />}
            ></ListItemText>
        </List>
    );

    const openBariumLink = (): void => {
        getBariumRequestMoreMembershipURL(Number(membershipId)).finally(() => setShowExternalLinkModal("NONE"));
        setShowExternalLinkModal("LOADING");
    };

    return (<>
        <div className="contentWrapper">
            <Banner
                title="subscriptions"
                subTitle="bannerSubscriptions"
                imageStyle={{ objectPosition: "66% 34%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/representatives/subscriptions.jpg`}
            />
            <TopBar
                searchField={<SearchField pagination={pagination} tag="searchSubscriptions" />}
                singleItem={<VKButton
                    size="small"
                    variant="outlined"
                    isLoading={showExternalLinkModal === "LOADING"}
                    disabled={showExternalLinkModal !== "NONE"}
                    onClick={() => setShowExternalLinkModal("SHOW_MODAL")} >
                    <LocalizeText tag="requestNewSubscriptions" />
                </VKButton>}
            />
            <SubscriptionsTable pagination={pagination} loading={pagination.query.isFetching} />
            {membership?.end_date && (
                <LocalizeText tag="inactivMembershipSubscriptionInfo" styling={{ padding: "10px" }} />
            )}
        </div>
        <ConfirmDialog
            open={showExternalLinkModal === "SHOW_MODAL"}
            title={<LocalizeText tag="confirmExternalLinkModalTitle" />}
            description={confirmExternalLinkModalDescription}
            hideRejectButton={true}
            onReject={() => setShowExternalLinkModal("NONE")}
            onAccept={() => openBariumLink()}
            acceptTag={"ok"}
        />
    </>
    );
};
export default SubscriptionsView;
